// @flow

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { connect } from "react-redux";

import actionCreators from "@modules/service/actionCreator";
import type { State } from "@store/reducers";
import type {
  BulkRegistrationEmailType,
  BulkRegistrationEmails,
} from "@modules/service/reducer/system-access/types";
import * as serviceSelectors from "@modules/service/selectors";
import { GSGrid, Container, Row, Pagination, Col } from "@components";
import { withClientContext, type PropsFromClientContext } from "@modules/context/components/";
import { getPagination } from "@selectors";
import { getUser } from "@modules/account/selectors";

type PropsFromState = $Exact<{
  emails: BulkRegistrationEmails,
  user: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  getBulkRegistrationEmails: typeof actionCreators.GetBulkRegistrationEmails,
}>;

type Props = $Exact<{
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromClientContext,
  ...PropsFromLocalize,
}>;

class SystemAccessEmailsGrid extends React.Component<Props> {
  componentDidMount() {
    let clientId =
      (this.props.client && this.props.client.id) || (this.props.user && this.props.user.clientId);

    if (clientId) {
      this.props.getBulkRegistrationEmails({ clientId, page: 1 });
    }
  }

  get gridData(): Array<BulkRegistrationEmailType> {
    return this.props.emails.content;
  }

  get config() {
    return [
      {
        key: "employeePrimaryRef",
        name: this.props.t("EMPLOYEE_REF"),
        align: "left",
      },
      {
        key: "firstName",
        name: this.props.t("FIRST_NAME"),
      },
      {
        key: "lastName",
        name: this.props.t("SURNAME"),
      },
      {
        key: "email",
        name: this.props.t("EMAIL"),
      },
    ];
  }

  get pagination(): Object {
    return getPagination(this.props.emails);
  }

  nextPage = (page: number) => {
    let clientId =
      (this.props.client && this.props.client.id) || (this.props.user && this.props.user.clientId);

    if (clientId) {
      this.props.getBulkRegistrationEmails({ clientId, page });
    }
  };

  render() {
    const pagination = this.pagination;

    return (
      <Container>
        <Row>
          <GSGrid rows={this.gridData} columns={this.config} />
        </Row>
        <Row>
          <Col md={{ size: 5, offset: 5 }} className="py-3">
            <Pagination
              className="mx-auto d-block"
              currentPage={pagination.pageNumber}
              totalPages={pagination.totalPages}
              onChange={this.nextPage}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => {
  return {
    emails: serviceSelectors.getBulkRegistrationEmails(state),
    user: getUser(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  getBulkRegistrationEmails: actionCreators.GetBulkRegistrationEmails,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
  withClientContext(),
)(SystemAccessEmailsGrid);
